import NotFound from "@/pages/NotFoundPage.vue";
import Home from "@/pages/Home.vue";
import Status from "@/pages/Status.vue";
import Certified from "@/pages/Certified.vue";

const routes = [{
    path: "/",
    name: "home",
    component: Home
},{
    path: "/asf/certified/:token",
    name: "certified",
    component: Certified
},{
    path: "/status",
    name: "status",
    component: Status
}, {
    path: "*",
    component: NotFound
}];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res = require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
